export const APP_NAME = "unifiedDashboard";
export const PRIMARY_TRACKER_ID = "sp1";
export const GROWTHBOOK_TRACKER_ID = "gb1";

export const DEFAULT_TRACKER_CONFIG = {
  cookieSameSite: "Lax",
  performanceTiming: true,
  minimumVisitLength: 30,
  heartbeatDelay: 10,
};
